import { IApplicationSpec, IPrivateAPIFixMe } from '../types';
import {
  IPlatformPrivateEvent,
  PlatformAppEventEmitter,
  IPlatformAppEvent,
} from '@wix/public-editor-platform-events';
import { PlatformEnvironment } from '@wix/editor-platform-contexts';

import { ApplicationEventsBridge } from '../ApplicationEventsBridge';

import { PlatformApplicationContainer } from './PlatformApplicationContainer';
import {
  AbstractEnvironmentAPI,
  PlatformConsumerEnvironmentAPIType,
} from '../AbstractEnvironmentAPI';

export class PlatformWorkerAPI extends AbstractEnvironmentAPI<
  PlatformConsumerEnvironmentAPIType.Worker,
  PlatformEnvironment.Worker
> {
  #events = new PlatformAppEventEmitter();

  #eventsBridge = new ApplicationEventsBridge(this.#events);
  #container: PlatformApplicationContainer | null = null;
  #privateAPI: IPrivateAPIFixMe;

  #pendingWaiters: ((value: this) => void)[] = [];

  constructor() {
    super(
      PlatformConsumerEnvironmentAPIType.Worker,
      PlatformEnvironment.Worker,
    );
  }

  create() {}

  async initEnvironment(props: {
    // TODO: should be Promise response in types
    buildPrivateAPI: (config: any) => IPrivateAPIFixMe;
  }) {
    const { buildPrivateAPI } = props;
    this.#privateAPI = await buildPrivateAPI({
      // TODO: should be per application (within the container before app execution)
      type: 'EDITOR_ADDON',
    });

    await this.injectEnvironmentContext({
      events: this.#events,
      privateApi: this.#privateAPI,
      applicationAPIs: {},
    });

    this.#container = new PlatformApplicationContainer(
      this.#privateAPI,
      this.#events,
    );

    this.#pendingWaiters.forEach((res) => res(this));
  }

  async notify(event: IPlatformPrivateEvent) {
    await this.waitReady();

    this.#eventsBridge.notify(event);
  }

  subscribe(cb: (event: IPlatformAppEvent) => void) {
    this.#eventsBridge.subscribe(cb);
  }

  async runApplication(app: IApplicationSpec) {
    await this.waitReady();

    await this.#container!.runApplication(app);
  }

  // TODO: should not be any waiters here
  // or should be implemented inside the events instances
  // collect queue until app is not ready
  public waitReady(): Promise<this> {
    return new Promise((res) => {
      if (this.#privateAPI) {
        return res(this);
      }

      this.#pendingWaiters.push(res);
    });
  }
}
